import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});



axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.config && (error.config.url.includes('/login') || error.config.url.includes('/register')) ) {
      return Promise.reject(error);
    }

    if (
      error.response && (error.response.status === 401 || error.response.status === 403)
    ) {
      // Clear local storage
      localStorage.removeItem('token');
      localStorage.removeItem('username');

      // Dispatch logout action
      const logoutEvent = new CustomEvent('jwt-expired');
      window.dispatchEvent(logoutEvent);

      // Show toast notification
      const toastEvent = new CustomEvent('show-toast', {
        detail: {
          message: 'Your session has expired. Please login again.',
          type: 'error'
        }
      });
      window.dispatchEvent(toastEvent);

      // Redirect to login page after short delay
      setTimeout(() => {
        window.location.href = '/login';
      }, 2000);

      return Promise.reject({
        message: 'Session expired. Please log in again.',
        expired: true,
      });
    }

    return Promise.reject(error);
  }
);



export { API_URL };
export default axiosInstance;
